import type { FC } from 'react';
import type { RulesItemProps } from './RulesItem.types';
import styles from './RulesItem.module.scss';
export const RulesItem: FC<RulesItemProps> = ({
  item
}) => <>
    {item.ruletitle && <h2 className={styles.title}>{item.ruletitle}</h2>}
    <div className={styles.content} dangerouslySetInnerHTML={{
    __html: item.rulecontent
  }} />
  </>;